// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { ArrowLeft, ShoppingCart, Flame } from "lucide-react";

// const NotFound = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-[#0f172a] px-6">
//       <div className="relative max-w-5xl w-full rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600">

//         {/* Glass overlay */}
//         <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" />

//         <div className="relative grid md:grid-cols-2 gap-10 p-10 md:p-16 text-white">
          
//           {/* Left Content */}
//           <div className="flex flex-col justify-center">
//             <span className="inline-flex items-center gap-2 text-sm font-medium bg-white/10 px-4 py-1 rounded-full w-fit">
//               <Flame className="w-4 h-4 text-yellow-400" />
//               Hot Deals Waiting
//             </span>

//             <h1 className="mt-6 text-7xl font-extrabold tracking-tight">
//               404
//             </h1>

//             <h2 className="mt-2 text-3xl font-semibold">
//               Oops! This page is sold out
//             </h2>

//             <p className="mt-4 text-white/80 max-w-md">
//               Looks like the page you’re searching for doesn’t exist.
//               But don’t worry — our store is full of amazing products.
//             </p>

//             {/* Buttons */}
//             <div className="mt-8 flex flex-wrap gap-4">
//               <button
//                 onClick={() => navigate("/")}
//                 className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-white text-gray-900 font-semibold hover:bg-gray-100 transition"
//               >
//                 <ArrowLeft className="w-5 h-5" />
//                 Back to Home
//               </button>

//               <button
//                 onClick={() => navigate("/")}
//                 className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-black/30 border border-white/20 hover:bg-black/40 transition"
//               >
//                 <ShoppingCart className="w-5 h-5" />
//                 Shop Now
//               </button>
//             </div>
//           </div>

//           {/* Right Visual Block */}
//           <div className="hidden md:flex items-center justify-center">
//             <div className="w-72 h-72 rounded-full bg-white/10 flex items-center justify-center animate-pulse">
//               <div className="w-48 h-48 rounded-full bg-white/10 flex items-center justify-center">
//                 <span className="text-6xl">🛒</span>
//               </div>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default NotFound;


import React from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingBag, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <section className="min-h-screen bg-gradient-to-br from-sky-50 via-white to-indigo-50 flex items-center justify-center px-4 sm:px-6">
      
      <div className="w-full max-w-5xl bg-white rounded-2xl shadow-lg overflow-hidden">
        
        <div className="grid grid-cols-1 md:grid-cols-2">
          
          {/* CONTENT */}
          <div className="p-6 sm:p-10 lg:p-14 flex flex-col justify-center">
            <span className="inline-block text-xs sm:text-sm font-semibold text-blue-600 bg-blue-50 px-3 py-1 rounded-full w-fit">
              404 Error
            </span>

            <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight">
              Page not found
            </h1>

            <p className="mt-3 text-sm sm:text-base text-gray-600 max-w-md">
              The page you’re looking for doesn’t exist or was moved.
              Don’t worry — our store has plenty to explore.
            </p>

            {/* BUTTONS */}
            <div className="mt-6 flex flex-col sm:flex-row gap-3 sm:gap-4">
              <button
                onClick={() => navigate(-1)}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg bg-blue-600 text-white text-sm sm:text-base font-medium hover:bg-blue-700 transition"
              >
                <ArrowLeft className="w-4 h-4 sm:w-5 sm:h-5" />
                Back
              </button>

              <button
                onClick={() => navigate("/")}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg border border-gray-300 text-gray-700 text-sm sm:text-base font-medium hover:bg-gray-50 transition"
              >
                <ShoppingBag className="w-4 h-4 sm:w-5 sm:h-5" />
                Shop
              </button>
            </div>

            {/* <button
              onClick={() => navigate(-1)}
              className="mt-4 inline-flex items-center gap-1 text-xs sm:text-sm text-gray-500 hover:text-gray-700 transition w-fit"
            >
              <ArrowLeft className="w-4 h-4" />
              Go back
            </button> */}
          </div>

          {/* VISUAL (hidden on mobile, visible on md+) */}
          <div className="hidden md:flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
            <div className="text-center px-6">
              <div className="text-[100px] lg:text-[140px] select-none">🛍️</div>
              <p className="mt-2 text-sm text-gray-500">
                Shopping never stops
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default NotFound;
